/*
 * @providesModule NativeNavigation
 *
 *
 */

import {SkillzRouter} from '@sdk-mobile';
import Cookies from 'js-cookie';
import getGameId from '@/utils/getGameId';
import {PARTNER_COOKIE_NAME, PARTNER_SESSION_MINT_FLAG} from '@/utils/constant';

const DestinationMap: Record<string, string> = {
  Store: 'store',
  Friends: 'referral-friend',
};

const NativeNavigation = {
  displayPostMatchSkillzUI: () => {},
  presentShareView: (subject: string, message: string, url: string) => {
    try {
      if (window.navigator.share) {
        window.navigator
          .share({
            title: subject,
            text: message,
            url: url,
          })
          .catch((e) => {
            if (e?.name === 'AbortError') {
              console.log('AbortError: Share was cancelled');
            } else {
              console.error('Error sharing:', e);
            }
          });
      } else {
        onShareTwitter(message, url);
      }
    } catch (e) {
      console.log('error on presenting share view:', e);
    }
  },

  gotoDestination: (destination: string) => {
    const gameId = getGameId();
    SkillzRouter.push(`/games/${gameId}/${DestinationMap[destination] ?? 'home'}`);
  },
  exitSkillz: () => {
    // Logout on the multicade web surface returns to the arcade home in a logged-out
    // state — the partner root (`/partner/{slug}`) when a partner is in context (its SDK
    // runtime then mints a fresh anon session and re-shows the FTUE), else the vanilla
    // root (`/`). A HARD navigation (not SkillzRouter.push) guarantees a fresh render with
    // the just-cleared auth cookies rather than a client-cached authed tree. Clear the
    // per-tab mint flag first, or the partner runtime (sessionStorage survives the reload)
    // sees it and never re-mints.
    const partner = Cookies.get(PARTNER_COOKIE_NAME);
    const dest = partner ? `/partner/${partner}` : '/';
    try {
      sessionStorage.removeItem(PARTNER_SESSION_MINT_FLAG);
    } catch {
      /* sessionStorage unavailable — nothing to clear */
    }
    fetch('/api/logout', {method: 'POST'})
      .catch(() => {})
      .finally(() => window.location.assign(dest));
  },
};

export default NativeNavigation;

function onShareTwitter(text: string, url: string) {
  const twitterShareUrl = `https://twitter.com/intent/tweet?text=${text}&url=${url}`;
  window.open(twitterShareUrl, 'Share on Twitter', 'width=700,height=500');
}
